import $ from 'jquery';
import Site from './components/Site';
/* cart stuff */
// import '@babel/polyfill/';
import './components/formBuy';
import './components/formCheckout';
import './components/updateCart';


/* cart popups */
// import Popup from './components/Popup';
// document.__popups = [];
// [...document.querySelectorAll('.popup')].forEach((popupElement) => {
//   document.__popups.push(new Popup(popupElement));
// });

// Variables
const $d = $(document),
  $w = $(window);

const site = new Site();
window.site = site;

history.pushState({}, '');



function setCookie() {
  // l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  $('.cookie').addClass('gone');
}

// Events
$d
  .ready(site.init)
  .on('click', '.cookie_btn', setCookie)
  .on('mouseenter', '.projects_thumb h2.t_title', site.workElementRollover)
  .on('mouseleave', '.projects_thumb h2.t_title', site.workElementRollover)
  .on('click', 'a.ajax', site.ajax)
  .on('click', '.reellink', function(e) {
    e.preventDefault();
    // l('show Reel');
    $('.reel').addClass('active');
  })
  .on('click', '.reel', function() {
    $('.reel').removeClass('active');
  })
  .on('click', '.film_logo a', function() {
    $('body.film').addClass('playvideo');
    $(".film_trailer iframe")[0].src += "?autoplay=1";

  })
  .on('click', '.film_close', function() {
    $('body.film').removeClass('playvideo');
    $(".film_trailer iframe")[0].src += "?autoplay=1";

  })
  .on('click', '.film_watchtrailer', function() {
    $('body.film').addClass('playvideo');
    $(".film_trailer iframe")[0].src += "?autoplay=1";

  })
  .on('click', '.crisp, .blur', function(){
    console.log('check');
    $('.crisp, .blur').addClass('out');
    // site.staggerReveal('nav ul li a.out', 150);
    // setTimeout(() => {
    //     site.revealShowreel(1500);
    // }, 4000);
  })
  .on('scroll', $w, site.filmButtons)
  
  .on('click', 'a.down', site.scrollToContent);
// .on("mousemove", $w, site.setBlurLevel);

$w.on('popstate', function (e) {
  if (e.originalEvent.state !== null) {
    site.loadPage(location.href);
  }
});
